import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map, of, switchMap, take } from 'rxjs';
import { TeamFacadeStrategy, TeamServiceStrategy } from '../../../feature-seatmap';
import { BIMPLUS_API } from '@web-portal/domains/shared/bimplus-core';

export const teamSlugGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const teamId = route.paramMap.get('teamId');
  const teamFacade = inject(TeamFacadeStrategy);
  const teamsService = inject(TeamServiceStrategy);
  const api = inject(BIMPLUS_API, { optional: true });
  const router = inject(Router);

  return teamFacade.teams$.pipe(
    take(1),
    switchMap(teams => {
      // If the requested team isn't in the current (possibly stale) value yet,
      // fetch the fresh list instead of proceeding with outdated data.
      if (!teams.some(team => team.id === teamId)) {
        return teamsService.getTeams();
      }
      return of(teams);
    }),
    map(teams => {
      const team = teams.find(team => team.id === teamId);
      if (!team?.slug) {
        return router.createUrlTree(['/']);
      }
      api?.setTeamSlug(team.slug);
      return true;
    })
  );
};
